import * as yup from 'yup';
import { Case } from 'types/items';

export const getInitialValues = (_case: Case | null) => ({
  sku: _case?.sku?._id || '',
  washHub: _case?.washHub?._id || '',
  rfid: (_case as any)?.rfid || '',
  status: _case?.status || 0,
});

export const validationSchema = yup.object().shape({
  washHub: yup.string().required('Required field'),
  rfid: yup.string().required('Required field'),
});
